import { UnknownError } from './error';

export function unknownErrorToMessage(
  err: unknown,
  defaultErrorMessage = 'Internal error.',
): string {
  const maybeError = err as UnknownError;
  if (typeof maybeError === 'string') return maybeError;
  const message =
    (maybeError && typeof maybeError.message === 'string' && maybeError.message) ||
    defaultErrorMessage;
  return message;
}
